import React from 'react';
import type { TabProps } from 'src/components/ui/tab';
import { Tab } from 'src/components/ui/tab';
import { cn } from 'src/utils/utils';

interface TabGroupProps {
  tabList: TabProps[];
  className?: string;
}

const TabGroup: React.FC<TabGroupProps> = ({ tabList, className }) => {
  if (!tabList.length) {
    return null;
  }

  return (
    <div className={cn('tw:flex tw:flex-wrap tw:gap-2xs', className)}>
      {tabList.map((tab, index) => (
        <Tab key={index} {...tab} />
      ))}
    </div>
  );
};

export default TabGroup;
